import { render } from "./FormAnalytics.vue?vue&type=template&id=bcf3aa32&scoped=true"
import script from "./FormAnalytics.vue?vue&type=script&lang=js"
export * from "./FormAnalytics.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=bcf3aa32&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf3aa32"]])

export default __exports__